/** Temporary stub — replace with environment-driven config when wiring real backend. */
export const MOCK_API_ORIGIN = 'https://api.klaro.local';

export const MOCK_JWT_ISSUER = 'https://auth.klaro.local';
export const MOCK_JWT_AUDIENCE = 'https://api.klaro.local';
export const MOCK_JWT_KID = 'mock-key-1';

export const MOCK_JWT_EXPIRES_IN_SECONDS = 12 * 60 * 60;

export const MOCK_PERSONA_STORAGE_KEY = 'klaro-mock-persona';

// There is deliberately no DEFAULT_MOCK_PERSONA here. This module is imported
// by production code (auth.service, the interceptor, the org and approvals
// services), so it must not pull the mock fixtures in to derive one -- and a
// literal is what went wrong before: the constant sat at 'owner.us', an
// identity matching no user in MOCK_USERS, read by nothing, while two other
// copies of the real default lived elsewhere. The default persona belongs to
// the fixtures and is derived in `mock-api.ts` from MOCK_USERS.
